// extracted by mini-css-extract-plugin
export default {"totalRow":"BaseTable_totalRow__mDKQv"};